const TRANSFER_ITEM_API_TYPE_FILE = 'file';
const TRANSFER_ITEM_API_TYPE_EMPTY_DIRECTORY = 'empty_directory';
const TransferItemAPITypes = {
  file: TRANSFER_ITEM_API_TYPE_FILE,
  empty_directory: TRANSFER_ITEM_API_TYPE_EMPTY_DIRECTORY,
};

const TRANSFER_ITEM_UI_TYPE_FILE = 'file';
const TRANSFER_ITEM_UI_TYPE_DIRECTORY = 'directory';
const TransferItemUITypes = {
  file: TRANSFER_ITEM_UI_TYPE_FILE,
  directory: TRANSFER_ITEM_UI_TYPE_DIRECTORY,
};

export { TransferItemAPITypes, TransferItemUITypes };
